<!-- StepComparisonProgress.vue -->
<template>
    <div class="modal_main_progres comparison-progress">
      <!-- Круглый прогресс -->
      <div class="progress-container" v-if="!isComplete">
        <svg width="246" height="246" viewBox="0 0 120 120">
          <defs>
            <linearGradient id="gradient" x1="1" y1="0" x2="0" y2="1">
              <stop offset="0%" stop-color="#8A75FF" />
              <stop offset="100%" stop-color="#FF3A99" />
            </linearGradient>
          </defs>
          <circle class="track" cx="60" cy="60" r="50" stroke-width="5" fill="none" />
          <circle class="progress" :stroke-dasharray="circumference"
            :stroke-dashoffset="progressOffset" cx="60" cy="60" r="50" stroke-width="5"
            stroke="url(#gradient)" fill="none" stroke-linecap="round" />
          <text x="60" y="65" text-anchor="middle" font-size="15" fill="white">
            {{ percentage }}%
          </text>
        </svg>
      </div>
  
      <!-- Результат сравнения -->
      <div class="comparison-result" v-else>
        <div class="comparison-header">
          <div class="head_logo">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"
              fill="none" stroke="oklch(.792 .209 151.711)" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
              <path d="m9 11 3 3L22 4"></path>
            </svg>
          </div>
          <h1>Сравнение документов завершено</h1>
        </div>
  
        <!-- Статистика -->
        <!-- <div class="stats-grid">
          <div class="stat-card">
            <div class="stat-value">{{ comparisonData?.summary_comparison?.compliance_stats?.compliant || 0 }}</div>
            <div class="stat-label">Полностью соответствует</div>
          </div>
          <div class="stat-card">
            <div class="stat-value">{{ comparisonData?.summary_comparison?.compliance_stats?.partially_compliant || 0 }}</div>
            <div class="stat-label">Частично соответствует</div>
          </div>
          <div class="stat-card">
            <div class="stat-value">{{ comparisonData?.summary_comparison?.compliance_stats?.non_compliant || 0 }}</div>
            <div class="stat-label">Не соответствует</div>
          </div>
          <div class="stat-card">
            <div class="stat-value">{{ comparisonData?.structure_comparison?.structure_compliance_percentage || 0 }}%</div>
            <div class="stat-label">Соответствие структуры</div>
          </div>
        </div> -->
  
        <!-- Карточки с результатами -->
        <div class="conformity-cards">
          <div v-for="(item, index) in conformityTable" :key="index" class="conformity-card" :class="getPriorityClass(item.priority)">
            <div class="card-header">
              <span class="card-title">{{ item.parameter }}</span>
              <span class="card-status" :class="getComplianceClass(item.compliance)">{{ item.compliance }}</span>
            </div>
            <div class="card-comment">{{ item.comment }}</div>
            <div class="card-recommendation" v-if="item.recommendation">
              <strong>Рекомендация:</strong> {{ item.recommendation }}
            </div>
          </div>
        </div>
  
        <!-- Общая оценка -->
        <!-- <div class="general-assessment">
          <h3>Общая оценка</h3>
          <p>{{ comparisonData?.summary_comparison?.general_assessment }}</p>
        </div> -->
  
        <!-- Заключение -->
        <!-- <div class="final-conclusion">
          <h3>Заключение</h3>
          <p>{{ comparisonData?.structure_comparison?.conclusion }}</p>
        </div> -->
  
        <!-- Следующие шаги -->
        <div class="next-steps" v-if="comparisonData?.final_comparison_assessment?.next_steps?.length">
          <h3>Рекомендуемые действия</h3>
          <ul>
            <li v-for="(step, index) in comparisonData.final_comparison_assessment.next_steps" :key="index">
              {{ step }}
            </li>
          </ul>
        </div>
  
        <div class="modal_main_load_content_btn" @click="$emit('continue')" style="cursor: pointer; margin-top: 32px;">
          <span>Продолжить</span>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'StepComparisonProgress',
    props: {
      percentage: {
        type: Number,
        default: 0
      },
      circumference: {
        type: Number,
        required: true
      },
      progressOffset: {
        type: Number,
        required: true
      },
      isComplete: {
        type: Boolean,
        default: false
      },
      comparisonData: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
        conformityTable() {
            return this.comparisonData?.structureData?.conformity_table || []
        }
    },
    methods: {
      getPriorityClass(priority) {
        const classes = {
          'Низкий': 'priority-low',
          'Средний': 'priority-medium',
          'Высокий': 'priority-high'
        }
        return classes[priority] || ''
      },
      getComplianceClass(compliance) {
  const classes = {
    'Соответствует': 'compliance-ok',
    'Частично соответствует': 'compliance-partial',
    'Не соответствует': 'compliance-bad'
  }
  return classes[compliance] || 'compliance-unknown'
}
    }
  }
  </script>
  
  <style scoped>
  .modal_main_progres {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 400px;
  }
  
  .progress-container {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 246px;
    height: 246px;
  }
  
  .track {
    stroke: #2c2c2c;
  }
  
  .progress {
    transform: rotate(-90deg);
    transform-origin: center;
    transition: stroke-dashoffset 0.5s ease;
  }
  
  .comparison-result {
    width: 100%;
    max-width: 800px;
    padding: 24px;
    background: #ffffff0a;
    border: 1px solid #403F6D;
    border-radius: 24px;
  }
  
  .comparison-header {
    text-align: center;
    margin-bottom: 32px;
  }
  
  .comparison-header h1 {
    margin: 16px 0 0;
    font-size: 24px;
  }
  
  .head_logo {
    display: flex;
    justify-content: center;
    width: max-content;
    margin: 0 auto;
  }
  
  .stats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    margin-bottom: 32px;
  }
  
  .stat-card {
    background: #ffffff15;
    padding: 20px;
    border-radius: 16px;
    text-align: center;
  }
  
  .stat-value {
    font-size: 32px;
    font-weight: 700;
    color: #8A75FF;
    margin-bottom: 8px;
  }
  
  .stat-label {
    font-size: 14px;
    color: #888;
  }
  
  .conformity-cards {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 32px;
  }
  
  .conformity-card {
    background: #ffffff15;
    border: 1px solid #403F6D;
    border-radius: 16px;
    padding: 20px;
  }
  
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }
  
  .card-title {
    font-size: 18px;
    font-weight: 600;
  }
  
  .card-status {
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
  }
  
  .compliance-ok {
    background: #00aa0020;
    color: #00ff00;
    border: 1px solid #00ff00;
  }
  
  .compliance-partial {
    background: #ffff0020;
    color: #ffff00;
    border: 1px solid #ffff00;
  }
  
  .compliance-bad {
    background: #ff000020;
    color: #ff6b6b;
    border: 1px solid #ff6b6b;
  }
  
  .priority-low {
    border-left: 4px solid #00ff00;
  }
  
  .priority-medium {
    border-left: 4px solid #ffff00;
  }
  
  .priority-high {
    border-left: 4px solid #ff6b6b;
  }
  
  .card-comment {
    color: #888;
    line-height: 1.6;
    margin-bottom: 12px;
  }
  
  .card-recommendation {
    color: #fff;
    padding: 8px 12px;
    background: #ffffff08;
    border-radius: 8px;
    font-size: 14px;
  }
  
  .general-assessment,
  .final-conclusion,
  .next-steps {
    margin-bottom: 32px;
  }
  
  .general-assessment h3,
  .final-conclusion h3,
  .next-steps h3 {
    font-size: 18px;
    margin-bottom: 12px;
    color: #8A75FF;
  }
  
  .general-assessment p,
  .final-conclusion p {
    color: #888;
    line-height: 1.6;
  }
  
  .next-steps ul {
    list-style: none;
    padding: 0;
  }
  
  .next-steps li {
    padding: 8px 16px;
    background: #ffffff08;
    border-radius: 8px;
    margin-bottom: 8px;
    color: #fff;
  }
  
  .modal_main_load_content_btn {
    display: flex;
    gap: 8px;
    width: 100%;
    padding: 18px 40px;
    background: #8A75FF;
    justify-content: center;
    border-radius: 24px;
    cursor: pointer;
    margin: 0 auto;
  }
  
  @media (max-width: 768px) {
    .stats-grid {
      grid-template-columns: repeat(2, 1fr);
    }
    
    .comparison-result {
      padding: 16px;
    }
  }
  .compliance-ok {
  background: #00aa0020;
  color: #00ff00;
  border: 1px solid #00ff00;
}

.compliance-partial {
  background: #ffff0020;
  color: #ffff00;
  border: 1px solid #ffff00;
}

.compliance-bad {
  background: #ff000020;
  color: #ff6b6b;
  border: 1px solid #ff6b6b;
}

/* Для неизвестных статусов */
.compliance-unknown {
    background: #ffff0020;
  color: #ffff00;
  border: 1px solid #ffff00;
}
  </style>